module.exports = __webpack_public_path__ + "static/media/video.2c019c60.svg";